/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  For getting the selectIsBot selector from the host
 * app into @zcode/lazy-loadable-section
 */

export type SelectIsBot = (state: any) => boolean

let selectIsBot: SelectIsBot | undefined

export const getSelectIsBot = () => {
  if (!selectIsBot) {
    throw new Error(
      'Must call setSelectIsBot(selectIsBot) before using createLazyLoadableSection'
    )
  }
  return selectIsBot
}

export const setSelectIsBot = (newSelectIsBot: SelectIsBot) => {
  selectIsBot = newSelectIsBot
}
